"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRentVoucherData = exports.rentVoucherFormRules = exports.rentVoucherSchema = void 0;
const converters_1 = require("../../converters");
const income_1 = require("./income");
exports.rentVoucherSchema = {
    fields: {
        ...income_1.incomeSchema.fields,
        frequency_id: {
            required: true,
        },
        amount: {
            min: 1,
            required: true,
        },
    },
    messages: {
        ...income_1.incomeSchema.messages,
        frequency_id: {
            required: 'Frequency is required',
        },
        amount: {
            required: 'Gross Income is required',
            min: 'Gross Income must be greater than 0',
        },
    },
};
// 🚀 Pre-computed validations for performance
exports.rentVoucherFormRules = (0, converters_1.toReactHookForm)(exports.rentVoucherSchema, income_1.incomeFieldMapping);
exports.validateRentVoucherData = (0, converters_1.createValidator)(exports.rentVoucherSchema);
